import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'bootstrap/dist/css/bootstrap.css';
import Routes from './routes/Routes';


ReactDOM.render(
  <React.StrictMode>
  <Routes/>    
  </React.StrictMode>,
  document.getElementById('root')
);

